module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"ui":{"components":{"products":{"collection_table":{"show_in_ranking":"Peergroup-Ranking"}}}}}}')
  delete Component.options._Ctor
}
